import { useEffect, useState } from 'react'
import { consumirApi } from '../utils/consumoApi'
import ErrorAlert from './../components/common/ErrorAlert'
import Table from './../components/tables/TableFilter'
import Button from './../components/common/Button'
import Modal from './../components/modals/Modal'
import ModalConfirmacion from './../components/modals/ModalConfirmacion'
import Form from './../components/forms/Form'
import Input from './../components/common/Input'
import Notification from './../components/common/Notification'
import Spinner from './../components/common/Spinner'

const Users = () => {
    const [datos, setDatos] = useState([])
    // campos 
    const [idUsuario, setIdUsuario] = useState("")
    const [dni, setDni] = useState("")
    const [nombres, setNombres] = useState("")
    const [apellidos, setApellidos] = useState("")
    const [email, setEmail] = useState("")
    const [accesoCotizaciones, setAccesoCotizaciones] = useState(false)
    const [accesoContratos, setAccesoContratos] = useState(false)
    const [accesoMaestros, setAccesoMaestros] = useState(false)
    const [accesoUsuarios, setAccesoUsuarios] = useState(false)
    // modales 
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
    // notificaciones y cargas 
    const [cargando, setCargando] = useState(true)
    const [cargandoReniec, setCargandoReniec] = useState(false)
    const [error, setError] = useState("")
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)
    //seleccion de fila
    const [selectedId, setSelectedId] = useState(null)
    //datos para la tabla
    const columnas = [
        { titulo: 'DNI', campo: 'dni_usuario' },
        { titulo: 'Nombres', campo: 'nombres_usuario' },
        { titulo: 'Apellidos', campo: 'apellidos_usuario' },
        { titulo: 'Correo', campo: 'email' },
        { titulo: 'Estado', campo: 'estado' },
    ]

    // Función para obtener usuarios de la API
    useEffect(() => {
        obtenerUsuarios()
    }, [])

    // Carga inicial de los usuarios
    const obtenerUsuarios = async () => {
        const respuesta = await consumirApi('GET', `users`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    // Funcion para buscar en la BD de RENIEC el DNI
    const obtenerPersona = async (dni) => {
        setDni(dni)
        setNombres('')
        setApellidos('')
        if (dni.length === 8) {
            setCargandoReniec(true)
            const respuesta = await consumirApi('GET', `reniec/${dni}`)
            const datos = respuesta.data[0]
            if (datos) {
                setNombres(datos.nombre)
                setApellidos(datos.ape_pat + ' ' + datos.ape_mat)
            }
            setCargandoReniec(false)
        }
    }

    // Función para registrar nuevo usuario
    const registrarUsuario = async (e) => {
        e.preventDefault()

        // Obtener los valores de los checkboxes de acceso a los módulos
        const accesos = {
            cotizaciones: accesoCotizaciones ? 1 : 0,
            contratos: accesoContratos ? 1 : 0,
            maestros: accesoMaestros ? 1 : 0,
            usuarios: accesoUsuarios ? 1 : 0,
        }

        // Crear el FormData
        const formData = new FormData(e.target)

        // Agregar los accesos al FormData
        formData.append('accesos', JSON.stringify(accesos)) // Puedes enviar el objeto como string JSON

        setIsSubmitting(true)

        // Enviar los datos al backend
        const respuesta = await consumirApi('POST', `users`, formData)

        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Usuario registrado correctamente" })
            limpiarCampos()
            obtenerUsuarios()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }


    // funcion para abrir el modal para editar usuarios
    const abrirModalEditar = async (data) => {
        setIdUsuario(data.id)
        setEmail(data.email)
        setMostrarModalEditar(true)
        setAccesoCotizaciones(data.usuario_permisos[0].acceso)
        setAccesoContratos(data.usuario_permisos[1].acceso)
        setAccesoMaestros(data.usuario_permisos[2].acceso)
        setAccesoUsuarios(data.usuario_permisos[3].acceso)
    }

    // Edición edicion usuario
    const enviarEdicionUsuario = async (e) => {
        e.preventDefault()
        const data = { email,accesoCotizaciones,accesoContratos,accesoMaestros,accesoUsuarios }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `users/${idUsuario}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Usuario actualizado correctamente" })
            limpiarCampos()
            obtenerUsuarios()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Manejar selección de checkbox
    const seleccionUsuario = (data) => {
        setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    }
  
    // funcion para abrir el modal para editar TipoTerreno
    const eliminarUsuario = async () => {
        const respuesta = await consumirApi('DELETE', `users/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Usuario eliminado correctamente" })
            limpiarCampos()
            obtenerUsuarios()
        } else {
            setError(respuesta.error)
        }
    }

    // funcion para abrir el modal para editar TipoTerreno
    const actualizarEstadoUsuario = async () => {
        const respuesta = await consumirApi('PATCH', `users/${selectedId}/estado`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Estado de usuario actualizado correctamente" })
            limpiarCampos()
            obtenerUsuarios()
        } else {
            setError(respuesta.error)
        }
    }

    const limpiarCampos = () => {
        setMostrarModal(false)
        setMostrarModalEditar(false)
        setMostrarModalEliminar(false)
        setSelectedId(null)
        setDni('')
        setNombres('')
        setApellidos('')
        setEmail('')
        setAccesoCotizaciones(0)
        setAccesoContratos(0)
        setAccesoMaestros(0)
        setAccesoUsuarios(0)
        setError('')
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
            <Button className="ml-3 mt-2"  type="delete" disabled={!selectedId} onClick={()=>setMostrarModalEliminar(true)} />
            <Button className="ml-3 mt-2" texto=" &#x21bb;" type="update" disabled={!selectedId} onClick={actualizarEstadoUsuario} />
            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5">No se encontraron usuarios</div>
                ) : (
                    <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
                        mostrarChecks={true}
                        seleccionFila={seleccionUsuario} // Manejar el ID seleccionado
                        selectedId={selectedId} // Manejar el ID seleccionado
                    />
                )
            )}

            {/* Modal Registrar nuevo Usuario */}
            <Modal isOpen={mostrarModal} title="Registrar nuevo usuario" onClose={limpiarCampos}>
                <Form onSubmit={registrarUsuario} isSubmitting={isSubmitting}>
                    <Input name="dni_usuario" value={dni} label="DNI" type='number' onChange={obtenerPersona} carga={cargandoReniec} />
                    <Input name="nombres_usuario" value={nombres} label="Nombres" onChange={setNombres} />
                    <Input name="apellidos_usuario" value={apellidos} label="Apellidos" onChange={setApellidos} />
                    <Input name="email" value={email} label="Email" onChange={setEmail} />

                    {/* Agregar los checkboxes para los módulos */}
                    <div className="mt-3">
                        <label className="block font-medium">Accesos a módulos</label>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="cotizaciones"
                                checked={accesoCotizaciones}
                                onChange={(e) => setAccesoCotizaciones(e.target.checked)}
                            />
                            <label htmlFor="cotizaciones" className="ml-2">Cotizaciones</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="contratos"
                                checked={accesoContratos}
                                onChange={(e) => setAccesoContratos(e.target.checked)}
                            />
                            <label htmlFor="contratos" className="ml-2">Contratos</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="maestros"
                                checked={accesoMaestros}
                                onChange={(e) => setAccesoMaestros(e.target.checked)}
                            />
                            <label htmlFor="maestros" className="ml-2">Maestros</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="usuarios"
                                checked={accesoUsuarios}
                                onChange={(e) => setAccesoUsuarios(e.target.checked)}
                            />
                            <label htmlFor="usuarios" className="ml-2">Usuarios</label>
                        </div>
                    </div>

                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>


            {/* Modal Actuazliar ubicacion*/}
            <Modal isOpen={mostrarModalEditar} title="Actualizar Usuario" onClose={limpiarCampos} >
                <Form onSubmit={enviarEdicionUsuario}  isSubmitting={isSubmitting} type='update'>
                    <Input name="email" value={email} label="Email" onChange={setEmail} />
                    
                    {/* Agregar los checkboxes para los módulos */}
                    <div className="mt-3">
                        <label className="block font-medium">Accesos a módulos</label>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="cotizaciones"
                                checked={accesoCotizaciones}
                                onChange={(e) => setAccesoCotizaciones(e.target.checked)}
                            />
                            <label htmlFor="cotizaciones" className="ml-2">Cotizaciones</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="contratos"
                                checked={accesoContratos}
                                onChange={(e) => setAccesoContratos(e.target.checked)}
                            />
                            <label htmlFor="contratos" className="ml-2">Contratos</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="maestros"
                                checked={accesoMaestros}
                                onChange={(e) => setAccesoMaestros(e.target.checked)}
                            />
                            <label htmlFor="maestros" className="ml-2">Maestros</label>
                        </div>
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="usuarios"
                                checked={accesoUsuarios}
                                onChange={(e) => setAccesoUsuarios(e.target.checked)}
                            />
                            <label htmlFor="usuarios" className="ml-2">Usuarios</label>
                        </div>
                    </div>
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar un tipo de terreno*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarUsuario}
                mensaje="¿Estás seguro de que deseas eliminar el usuario?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>

        </div>
    )
}

export default Users
